import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export class FirmaWebsocketService {
  private socket!: WebSocket;
  public onMessage: (data: any) => void = () => { };
  public onOpen: () => void = () => { };
  public onClose: (event) => void = () => { };

  connect(token: string): void {
    // construye la url eliminando el context path si existe
    const baseUrl = environment.wsUrl;
    const wsUrl = `${baseUrl}?token=${token}`;

    this.socket = new WebSocket(wsUrl);

    this.socket.onopen = () => {
      this.onOpen();
    };

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      this.onMessage(data);
    };

    this.socket.onclose = () => {
      // Emitir un aviso al componente
      this.onClose(event);
      // También podrías reenviar al agente:
      this.send({ tipo: 'cliente_desconectado' });
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
  }

  send(data: any): void {
    if (this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
    }
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.close();
    }
  }
}
